import { render, staticRenderFns } from "./FsSortViewMenu.vue?vue&type=template&id=671fbdc8&"
import script from "./FsSortViewMenu.vue?vue&type=script&lang=js&"
export * from "./FsSortViewMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports